/**
 * Control de divulgación de identidad de cliente (Fase 4, cierre de confirmaciones).
 *
 * Mientras un caso no tenga autorización escrita del cliente, el sitio público
 * muestra su versión anónima (industria, problema, estrategia, metodología,
 * aplicaciones y aprendizajes) sin revelar marca ni empresa.
 *
 * Para activar el nombre real más adelante basta con poner el slug en `true`:
 * no hay que rehacer la página.
 */
export const CLIENT_NAME_DISCLOSURE: Record<string, boolean> = {
  "el-nino-aguas-frescas-branding": false,
  "marca-abrasivos-amazon-usa": false,
};

/** Títulos públicos anónimos usados mientras la autorización esté pendiente. */
export const ANONYMOUS_CASE_TITLES: Record<string, { es: string; en: string }> = {
  "el-nino-aguas-frescas-branding": {
    es: "Empresa de bebidas en EE. UU. — Branding para el mercado hispano",
    en: "U.S. Beverage Company — Hispanic Market Branding",
  },
  "marca-abrasivos-amazon-usa": {
    es: "Marca mexicana de abrasivos — Amazon USA e internacional",
    en: "Mexican Abrasives Brand — Amazon USA and international",
  },
};

export const isClientNameDisclosed = (slug: string): boolean =>
  CLIENT_NAME_DISCLOSURE[slug] === true;

/** Título a mostrar públicamente según el estado de autorización. */
export const getPublicCaseTitle = (
  slug: string,
  realTitle: string,
  language: "es" | "en",
): string => {
  if (isClientNameDisclosed(slug)) return realTitle;
  return ANONYMOUS_CASE_TITLES[slug]?.[language] ?? realTitle;
};
